import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-20" data-testid="forgot-password-page">
      <div className="font-mono text-[10px] uppercase tracking-[0.35em] text-zinc-500 mb-4">
        {t("brand")}
      </div>
      <h1 className="font-serif text-4xl sm:text-5xl text-zinc-50 font-light tracking-tight leading-none">
        {t("forgot_title")}
      </h1>
      <p className="mt-5 text-zinc-400 font-light leading-relaxed">
        {t("forgot_lead")}
      </p>

      {sent ? (
        <div
          className="mt-10 border border-zinc-800 bg-zinc-900/40 px-5 py-6 text-zinc-200 font-light leading-relaxed"
          data-testid="forgot-password-sent"
        >
          {t("forgot_sent")}
        </div>
      ) : (
        <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="forgot-password-form">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
              {t("email")}
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border border-zinc-800 px-4 py-3 text-zinc-100 font-light focus:outline-none focus:border-zinc-500"
              data-testid="forgot-password-email-input"
              autoFocus
            />
          </div>
          {error && (
            <div className="border border-red-900 bg-red-950/30 text-red-300 px-4 py-3 text-sm" data-testid="forgot-password-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-sienna text-white py-3 text-sm font-light hover:bg-sienna-400 disabled:opacity-60 transition-colors"
            data-testid="forgot-password-submit"
          >
            {busy ? t("loading") : t("forgot_submit")}
          </button>
        </form>
      )}

      <div className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">
        <Link
          to="/login"
          className="text-zinc-100 hover:text-white underline-offset-4 hover:underline"
          data-testid="forgot-password-back-link"
        >
          ← {t("sign_in")}
        </Link>
      </div>
    </div>
  );
}
